<template lang="pug">
el-dialog(:title="title" :visible="visible" :before-close="hide")
    el-form(v-if="editItem === 'displayName'" :model="form" ref="form")
        el-form-item(prop="displayName")
            el-input(v-model="form.displayName")
    el-form(v-if="editItem === 'email'" :model="form" :rules="emailRules" ref="form")
        el-form-item(prop="email" label="邮箱" label-width="120px")
            el-input(v-model="form.email")
        el-form-item(prop="code" label="验证码" label-width="120px")
            el-input(v-model="form.code")
                el-button(slot="append" icon="el-icon-s-promotion" @click="createEmailCode" :disabled="display.emailCodeBtn.disabled") {{ emailCodeBtnText }}
    el-form(v-if="editItem === 'phoneNumber'" :model="form" :rules="phoneNumberRules" ref="form")
        el-form-item(prop="phoneNumber" label="电话号码" label-width="80px")
            el-input(v-model="form.phoneNumber")
        el-form-item(prop="code" label="验证码" label-width="80px")
            el-input(v-model="form.code")
                el-button(slot="append" icon="el-icon-mobile-phone" @click="createPhoneCode" :disabled="display.phoneCodeBtn.disabled") {{ phoneCodeBtnText }}
    .dialog-footer(slot="footer")
        el-button(@click="hide") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
import {
    updateUserAPI,
    createPhoneCodeAPI,
    updateUserPhoneNumberAPI,
    createEmailCodeAPI,
    updateUserEmailAPI
} from "@/services";
const defaultForm = {
    displayName: "",
    email: "",
    phoneNumber: "",
    description: ""
};
const defaultPhoneCodeBtn = {
    disabled: false,
    countDown: 0
};
const defaultEmailCodeBtn = {
    disabled: false,
    countDown: 0
};
export default {
    name: "userProfileEditForm",
    props: ["visible", "editing", "editItem"],
    data() {
        const validatePhoneNumber = (rule, value, callback) => {
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("手机号码格式错误"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            title: null,
            form: Object.assign({}, defaultForm),
            display: {
                displayName: "昵称",
                email: "邮箱",
                phoneNumber: "电话号码",
                phoneCodeBtn: Object.assign({}, defaultPhoneCodeBtn),
                emailCodeBtn: Object.assign({}, defaultEmailCodeBtn)
            },
            emailRules: {
                email: [
                    {
                        type: "email", //要检验的类型（number，email，date等）
                        message: "请输入正确的邮箱地址",
                        trigger: ["blur", "change"]
                    }
                ]
            },
            phoneNumberRules: {
                phoneNumber: [
                    {
                        required: true,
                        validator: validatePhoneNumber,
                        trigger: ["blur"]
                    }
                ],
                code: [
                    {
                        required: true,
                        message: "验证码不能为空",
                        trigger: ["blur"]
                    }
                ]
            }
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async updateUser() {
            this.loading = true;
            try {
                const res = await updateUserAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$emit("refresh");
                    this.$message.success("保存成功");
                } else {
                    throw new Error();
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async createPhoneCode() {
            this.loading = true;
            try {
                const res = await createPhoneCodeAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 201) {
                    this.$message.success("短信验证码已发送，请查收");
                    this.display.phoneCodeBtn.countDown = 60;
                } else {
                    throw new Error();
                }
            } catch (err) {
                if (
                    err.status === 400 &&
                    err.data.title === "Constraint Error"
                ) {
                    this.$message.warning("该手机号已注册占用");
                } else {
                    this.$message.error("服务器开小差了，请尝试重新操作");
                }
            } finally {
                this.loading = false;
                this.countDownTimer();
            }
        },
        async updateUserPhoneNumber() {
            this.loading = true;
            try {
                const res = await updateUserPhoneNumberAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$emit("refresh");
                    this.$message.success("保存成功");
                } else {
                    throw new Error();
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        async createEmailCode() {
            this.loading = true;
            try {
                const res = await createEmailCodeAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 201) {
                    this.$message.success("邮箱证码已发送，请查收");
                    this.display.emailCodeBtn.countDown = 300;
                } else {
                    throw new Error();
                }
            } catch (err) {
                if (
                    err.status === 400 &&
                    err.data.title === "Constraint Error"
                ) {
                    this.$message.warning("该邮箱已注册占用");
                } else {
                    this.$message.error("服务器开小差了，请尝试重新操作");
                }
            } finally {
                this.loading = false;
                this.countDownTimer();
            }
        },
        async updateUserEmail() {
            this.loading = true;
            try {
                const res = await updateUserEmailAPI(
                    this.editing.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$emit("refresh");
                    this.$message.success("保存成功");
                } else {
                    throw new Error();
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        hide() {
            this.$emit("hide");
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    console.log("error submit!!");
                    return false;
                }
                if (this.editItem == "phoneNumber") {
                    this.updateUserPhoneNumber();
                } else if (this.editItem == "email") {
                    this.updateUserEmail();
                } else {
                    this.updateUser();
                }
                this.form = Object.assign({}, defaultForm);
                this.hide();
            });
        },
        countDownTimer() {
            if (this.display.phoneCodeBtn.countDown > 0) {
                setTimeout(() => {
                    this.display.phoneCodeBtn.countDown -= 1;
                    this.countDownTimer();
                }, 1000);
            }
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.title = "编辑" + this.display[this.editItem];
                this.form = Object.assign({}, defaultForm, this.editing);
            } else {
                this.form = Object.assign({}, defaultForm);
            }
        },
        "display.phoneCodeBtn.countDown": {
            handler(val) {
                if (val) {
                    this.display.phoneCodeBtn.disabled = true;
                } else {
                    this.display.phoneCodeBtn.disabled = false;
                }
            },
            immediate: true
        },
        "display.emailCodeBtn.countDown": {
            handler(val) {
                if (val) {
                    this.display.emailCodeBtn.disabled = true;
                } else {
                    this.display.emailCodeBtn.disabled = false;
                }
            },
            immediate: true
        }
    },
    computed: {
        phoneCodeBtnText: function() {
            if (this.display.phoneCodeBtn.countDown === 0) {
                return "获取短信验证码";
            } else {
                return `${this.display.phoneCodeBtn.countDown}s后重新获取`;
            }
        },
        emailCodeBtnText: function() {
            if (this.display.emailCodeBtn.countDown === 0) {
                return "获取邮箱验证码";
            } else {
                return `${this.display.emailCodeBtn.countDown}s后重新获取`;
            }
        }
    }
};
</script>
